import {useMemo} from 'react'

import {useAction} from '../../actions'
import {useStatusContext} from '../../contexts/StatusContext'
import {useFormUserEventHandler} from '../../lib/metrika'
import type {ActionButtonSlot, ActionButtonWidgetProps as Props} from '../types'

const ALIGN_ORDER: Record<string, number> = {leading: 0, center: 1, trailing: 2}

function getSortedSlots(style: {slot?: ActionButtonSlot; slot2?: ActionButtonSlot; slot3?: ActionButtonSlot}) {
  return [style.slot, style.slot2, style.slot3]
    .filter((s): s is ActionButtonSlot => Boolean(s))
    .sort((a, b) => (ALIGN_ORDER[a.align] ?? 1) - (ALIGN_ORDER[b.align] ?? 1))
}

export function useActionButtonProps({config}: Props) {
  const {button_size, loading_style, normal_style, action, metrica_label, widget_id} = config
  const {isFetching} = useStatusContext()
  const style = isFetching ? loading_style : normal_style
  const {ActionComponent: actionElement, triggerAction} = useAction(action ? {...action, widget_id} : void 0)
  const handleReachGoal = useFormUserEventHandler()
  const slots = useMemo(() => getSortedSlots(style), [style])

  function handlePress() {
    metrica_label && handleReachGoal(metrica_label)
    triggerAction?.()
  }

  return {
    size: button_size,
    loading: isFetching,
    handlePress: isFetching ? undefined : handlePress,
    style,
    slots,
    actionElement,
  } as const
}
